export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7754.aa22384c.jpg";